import React, { useState, useRef, useEffect, useCallback } from "react";
import { Popover, Input, Button } from "../../BP2Components";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import { Icon_Filter } from "../../BP2Components/Icons/icons";
import { ListScripts } from "../ListWidget/Lists/listScripts";

const FilterPopoverContent = ({ colTechName, listId, appliedValue, onSearch, onRemove, intl }) => {
   const [typed, setTyped] = useState(appliedValue);

   useEffect(() => {
      setTyped(appliedValue);
   }, [appliedValue]);

   return (
      <div style={{ padding: 8, width: 205 }}>
         <Input
            placeholder={appliedValue || intl.formatMessage({ id: "filter.search" })}
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            onPressEnter={() => onSearch(listId, colTechName, typed)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
         />
         <Button
            buttonType="primary"
            onClick={() => onSearch(listId, colTechName, typed)}
            size="small"
            style={{ width: 90, marginRight: 8 }}
         >
            <IntlMessages id="filter.search" />
         </Button>
         <Button onClick={() => onRemove(listId, colTechName)} size="small" style={{ width: 90 }}>
            <IntlMessages id="filter.reset" />
         </Button>
      </div>
   );
};

const TableFilter = ({ GUID, listId, filters, setFilters, loadTableData }) => {
   const intl = useIntl();
   const loadTableDataRef = useRef(loadTableData);
   loadTableDataRef.current = loadTableData;

   const removeFilter = useCallback(
      (currentListId, keyToRemove) => {
         setFilters((prev) => {
            const updated = { ...prev };
            if (updated[currentListId]) {
               const inner = { ...updated[currentListId] };
               delete inner[keyToRemove];
               updated[currentListId] = inner;
            }
            return updated;
         });
         loadTableDataRef.current(true);
         ListScripts.handleDeleteFilterFromUrl(GUID, keyToRemove);
      },
      [GUID, setFilters],
   );

   const handleSearch = useCallback(
      (currentListId, key, value) => {
         setFilters((prev) => ({
            ...prev,
            [currentListId]: { ...(prev[currentListId] ?? {}), [key]: value },
         }));
         ListScripts.handleAddFilterToUrl(GUID, key, value);
         loadTableDataRef.current(true);
      },
      [GUID, setFilters],
   );

   const filter = useCallback(
      (colTechName) => {
         const appliedValue = filters?.[listId]?.[colTechName] ?? "";
         return (
            <Popover
               trigger="click"
               placement="bottom"
               content={
                  <FilterPopoverContent
                     colTechName={colTechName}
                     listId={listId}
                     appliedValue={appliedValue}
                     onSearch={handleSearch}
                     onRemove={removeFilter}
                     intl={intl}
                  />
               }
            >
               <div className="column-header__actions__filter__icon">
                  <Icon_Filter className={appliedValue ? " filtered" : ""} />
               </div>
            </Popover>
         );
      },
      [filters, listId, intl, handleSearch, removeFilter],
   );

   return { filter };
};

export default TableFilter;
